import _ from 'lodash';

export function getRandomUuid() {
  return _.shuffle(
    Math.random()
      .toString(36)
      .replace('0.', Date.now().toString(36))
  ).join('');
}
